/**
 * Feature Flags Configuration
 * 
 * Controls visibility and availability of application features.
 * Feature flags are set via environment variables and evaluated at build time.
 * 
 * @see .kiro/specs/hide-monetization-ui/requirements.md
 */

export const FEATURES = {
  /**
   * Controls visibility of monetization features (shop, purchases, upgrades)
   * 
   * When disabled:
   * - Shop navigation links are hidden
   * - Buy Coins buttons are hidden
   * - Membership upgrade UI is hidden
   * - /shop route redirects to dashboard
   * 
   * When enabled:
   * - All monetization features are visible and functional
   * 
   * @default false
   * @env VITE_ENABLE_MONETIZATION
   */
  ENABLE_MONETIZATION: import.meta.env.VITE_ENABLE_MONETIZATION === 'true',
} as const;

export type FeatureFlags = typeof FEATURES;
